import { QuotationProductProps } from './quotation.type'
import { SupplierProductProps } from './supplier-product.type'

export enum SupplierForecastAgreementEnum {
  'formal' = 'formal',
  'informal' = 'informal',
}

export interface SupplierForecastProps {
  uuid?: string
  quantity?: number
  cost?: number
  currency?: 'MXN' | 'USD'
  agreementType?: keyof typeof SupplierForecastAgreementEnum
  agreementReference?: string
  supplierProductUuid?: string
  supplierProduct?: SupplierProductProps
  reference: string
  quantityUsed: number
  availableQuantity: number
  productQuotations?: QuotationProductProps[]
  expiresAt?: string
  createdAt?: string
  updatedAt?: string
}

export interface SupplierForecastListWithPagesProps {
  count: number
  next?: string
  previous?: string
  results?: SupplierForecastProps[]
}
